module.exports = __webpack_public_path__ + "static/media/nest_fall_down_page10.79eb5b34.png";